import { useState, useEffect } from 'react';

function Popup({ onBoarding }) {
    const [date, setDate] = useState();
    const [time, setTime] = useState();
    const [IstTime, setIstTime] = useState();
    const [address, setAddress] = useState();
    const [disable, setDisable] = useState(true);
    useEffect(() => {
        onBoardings();
    }, [date, time, address]);
    const onBoardings = () => {
        let istStartTime;
        let result = true;
        if (date == undefined || date == '') {
            // setValidation((validate) => ({ ...validate, date: 'Select a valid date' }));
            result = false;
        }
        if (time == undefined || time == '') {
            result = false;
        } else {
            let starttimevalue = time;
            let end = starttimevalue.split(':');

            var currentTime = new Date();

            let arr = currentTime.toString().split(' ');
            arr[4] = `${end[0]}:${end[1]}:00`;
            currentTime = new Date(arr.join(' '));

            var currentOffset = currentTime.getTimezoneOffset();

            var ISTOffset = 330;

            var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

            var hoursIST = ISTTime.getHours();
            var minutesIST = ISTTime.getMinutes();

            istStartTime = hoursIST + ':' + minutesIST;

            setIstTime(istStartTime);
        }
        if (address == undefined || address == '' || address == 'Select') {
            // setValidation((validate) => ({ ...validate, date: 'Select a valid date' }));
            result = false;
        }

        if (result == true) {
            setDisable(false);
        } else {
            setDisable(true);
        }
    };
    const onBoarding1 = () => {
        let istStartTime;
        let result = true;
        if (date == undefined || date == '') {
            // setValidation((validate) => ({ ...validate, date: 'Select a valid date' }));
            result = false;
        }
        if (time == undefined || time == '') {
            result = false;
        } else {
            let starttimevalue = time;
            let end = starttimevalue.split(':');

            var currentTime = new Date();

            let arr = currentTime.toString().split(' ');
            arr[4] = `${end[0]}:${end[1]}:00`;
            currentTime = new Date(arr.join(' '));

            var currentOffset = currentTime.getTimezoneOffset();

            var ISTOffset = 330;

            var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

            var hoursIST = ISTTime.getHours();
            var minutesIST = ISTTime.getMinutes();

            istStartTime = hoursIST + ':' + minutesIST;

            setIstTime(istStartTime);
        }
        if (address == undefined || address == '' || address == 'Select') {
            // setValidation((validate) => ({ ...validate, date: 'Select a valid date' }));
            result = false;
        }

        if (result == true) {
            setDisable(false);
        } else {
            setDisable(true);
        }
        if (
            address !== undefined &&
            address !== '' &&
            address !== 'Select' &&
            date !== undefined &&
            date !== '' &&
            time !== undefined &&
            time !== ''
        ) {
            onBoarding(date, istStartTime, address);
        }
    };

    return (
        <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog addfamily-popup modal-dialog-centered">
                <div className="modal-content px-2">
                    <div className="modal-header border-0 px-2">
                        <h5 className="modal-title addfam-text-blue bold-text font-16" id="exampleModalLabel">
                            Announce Onboarding Date
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body py-0 px-1">
                        <div>
                            <div className="row py-2 align-items-center">
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <label
                                        htmlFor="selectreason"
                                        className="form-label form-label-sm addfamily-label-clr semibold-text font-13"
                                    >
                                        Schedule Date
                                    </label>
                                    <span className="required">*</span>
                                </div>
                                <div className="col-lg-8 col-md-8 col-sm-12">
                                    <input
                                        type="date"
                                        className="form-control hive-form-control"
                                        id="selectreason"
                                        onChange={(e) => {
                                            setDate(e.target.value);
                                        }}
                                        aria-label="Default select example"
                                        min={new Date().toISOString().split('T')[0]}
                                    />
                                </div>
                            </div>
                            <div className="row py-2 align-items-center">
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <label
                                        htmlFor="selectreason"
                                        className="form-label form-label-sm addfamily-label-clr semibold-text font-13"
                                    >
                                        Schedule Time
                                    </label>
                                    <span className="required">*</span>
                                </div>
                                <div className="col-lg-8 col-md-8 col-sm-12">
                                    <input
                                        type="time"
                                        className="form-control hive-form-control"
                                        id="selectreason"
                                        onChange={(e) => {
                                            setTime(e.target.value);
                                        }}
                                        aria-label="Default select example"
                                    />
                                </div>
                            </div>
                            <div className="row py-2 align-items-center">
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <label
                                        htmlFor="selectreason"
                                        className="form-label form-label-sm addfamily-label-clr semibold-text font-13"
                                    >
                                        Venue
                                    </label>
                                    <span className="required">*</span>
                                </div>
                                <div className="col-lg-8 col-md-8 col-sm-12">
                                    <select
                                        className="form-select hive-form-select"
                                        onChange={(e) => {
                                            setAddress(e.target.value);
                                        }}
                                        id="departmentID"
                                        name="dropdown"
                                    >
                                        <option value="Select">Select</option>
                                        <option value="Bayline">Bayline</option>
                                        <option value="SSPDL">SSPDL</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn cancel-button bold-text font-14 me-3" data-bs-dismiss="modal">
                            Cancel
                        </button>
                        <button
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="btn hive-btn-primary bold-text font-14"
                            onClick={() => {
                                onBoarding1(date);
                            }}
                            disabled={disable}
                        >
                            Announce
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Popup;
